import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ng-diversions-cancel',
  templateUrl: './diversions-cancel.dialog.html',
  styleUrls: ['./diversions-cancel.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiversionsCancelDialog {
  @Output() cancelDiversion = new EventEmitter();
  formGroup: UntypedFormGroup = new UntypedFormGroup({
    reason: new UntypedFormControl('', Validators.required)
  });

  constructor() { }
}
